module.exports = new __parcel__URL__("sehnsucht.6fe7b764.jpg").toString();